export const TASK_ACTION_HISTORY_ACTION_TYPE_MAP = {
  complete: 'COMPLETE',
  revoke: 'REVOKE',
} as const

export const TASK_ACTION_HISTORY_DOMAIN_MAP = {
  task: 'TASK',
  action: 'ACTION',
} as const
